import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n13 = 0, F = function F() {}; return { s: F, n: function n() { return _n13 >= r.length ? { done: !0 } : { done: !1, value: r[_n13++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isString as e } from "../utils/isString.js";
import { isNode as t } from "../utils/isNode.js";
import { getScrollableParent as n } from "../utils/getScrollableParent.js";
import { stringToHtml as i } from "../utils/strToHtml.js";
import { clamp as o } from "../utils/clamp.js";
import { Tween as a } from "../libs/tween.js";
import { getMidpoint as s, getChangedPosition as r, Gestures as l } from "../libs/gestures.js";
import { en_EN as c } from "./l10n/en_EN.js";
import { addClass as u } from "../utils/addClass.js";
import { removeClass as d } from "../utils/removeClass.js";
import { toggleClass as f } from "../utils/toggleClass.js";
var g = function g(e) {
    e.cancelable && e.preventDefault();
  },
  h = function h(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e4;
    return e = parseFloat(e + "") || 0, Math.round((e + Number.EPSILON) * t) / t;
  },
  m = function m(e) {
    return e instanceof HTMLImageElement;
  };
var p, v;
!function (e) {
  e.Reset = "reset", e.Zoom = "zoom", e.ZoomIn = "zoomIn", e.ZoomOut = "zoomOut", e.ZoomTo = "zoomTo", e.ToggleCover = "toggleCover", e.ToggleFull = "toggleFull", e.ToggleMax = "toggleMax", e.IterateZoom = "iterateZoom", e.Pan = "pan", e.Swipe = "swipe", e.Move = "move", e.MoveLeft = "moveLeft", e.MoveRight = "moveRight", e.MoveUp = "moveUp", e.MoveDown = "moveDown", e.RotateCCW = "rotateCCW", e.RotateCW = "rotateCW", e.FlipX = "flipX", e.FlipY = "flipY";
}(p || (p = {})), function (e) {
  e.Cover = "cover", e.Full = "full", e.Max = "max";
}(v || (v = {}));
var b = {
    x: 0,
    y: 0,
    scale: 1,
    angle: 0,
    flipX: 1,
    flipY: 1
  },
  y = {
    bounds: !0,
    classes: {
      container: "f-panzoom",
      wrapper: "f-panzoom__wrapper",
      content: "f-panzoom__content",
      viewport: "f-panzoom__viewport"
    },
    clickAction: p.ToggleFull,
    dblClickAction: !1,
    gestures: {},
    height: "auto",
    l10n: c,
    maxScale: 4,
    minScale: 1,
    mouseMoveFactor: 1,
    panMode: "drag",
    protected: !1,
    singleClickAction: !1,
    spinnerTpl: '<div class="f-spinner"></div>',
    wheelAction: p.Zoom,
    width: "auto"
  };
var x,
  w = 0,
  M = 0,
  j = 0;
var k = function k(c) {
  var v = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var k = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var E,
    C,
    O,
    A,
    S,
    T,
    F,
    Z,
    L = 0,
    X = Object.assign(Object.assign({}, y), v),
    Y = {},
    R = Object.assign({}, b),
    P = Object.assign({}, b);
  var z = [];
  function D(e) {
    var t = X[e];
    return t && "function" == typeof t ? t(xe) : t;
  }
  function I() {
    return c && c.parentElement && E && 3 === L;
  }
  var W = new Map();
  function H(e) {
    var n = _toConsumableArray(W.get(e) || []);
    X.on && n.push(X.on[e]);
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }
    var _iterator = _createForOfIteratorHelper(n),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e = _step.value;
        _e && _e instanceof Function && _e.apply(void 0, [xe].concat(t));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    "*" !== e && H.apply(void 0, ["*", e].concat(t));
  }
  function q(e) {
    if (!I()) return;
    var t = e.target;
    if (n(t)) return;
    var i = Date.now(),
      a = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (e, t) {
        return Math.abs(t) > Math.abs(e) ? t : e;
      }),
      s = o(-1, a, 1);
    H("wheel", e, s);
    var r = D("wheelAction");
    if (!r) return;
    if (e.defaultPrevented) return;
    var l = P.scale;
    var c = l * (s > 0 ? 1.5 : .5);
    if (r === p.Zoom) {
      var _t = Math.abs(e.deltaY) < 100 && Math.abs(e.deltaX) < 100;
      if (i - M < (_t ? 200 : 45)) return void g(e);
      M = i;
      var _n = te(),
        _a = ae();
      if (h(c) < h(_n) && h(l) <= h(_n) ? (j += Math.abs(s), c = _n) : h(c) > h(_a) && h(l) >= h(_a) ? (j += Math.abs(s), c = _a) : (j = 0, c = o(_n, c, _a)), j > 7) return;
    }
    switch (g(e), r) {
      case p.Pan:
        ce(r, {
          srcEvent: e,
          deltaX: 2 * -e.deltaX,
          deltaY: 2 * -e.deltaY
        });
        break;
      case p.Zoom:
        ce(p.ZoomTo, {
          srcEvent: e,
          scale: c,
          center: {
            x: e.clientX,
            y: e.clientY
          }
        });
        break;
      default:
        ce(r, {
          srcEvent: e
        });
    }
  }
  function $(e) {
    var n, i;
    var o = e.composedPath()[0];
    if (!l.isClickAllowed()) return;
    if (!t(o) || e.defaultPrevented) return;
    if (!(null == c ? void 0 : c.contains(o))) return;
    if (o.hasAttribute("disabled") || o.hasAttribute("aria-disabled")) return;
    var a = o.closest("[data-panzoom-action]"),
      s = null === (n = null == a ? void 0 : a.dataset) || void 0 === n ? void 0 : n.panzoomAction,
      r = (null === (i = null == a ? void 0 : a.dataset) || void 0 === i ? void 0 : i.panzoomValue) || "";
    if (s) {
      switch (s) {
        case p.ZoomTo:
        case p.ZoomIn:
        case p.ZoomOut:
          ce(s, {
            scale: parseFloat(r || "") || void 0
          });
          break;
        case p.MoveLeft:
        case p.MoveRight:
          ce(s, {
            deltaX: parseFloat(r || "") || void 0
          });
          break;
        case p.MoveUp:
        case p.MoveDown:
          ce(s, {
            deltaY: parseFloat(r || "") || void 0
          });
          break;
        default:
          ce(s);
      }
      return;
    }
    if (!(null == E ? void 0 : E.contains(o))) return;
    var u = {
      srcEvent: e
    };
    if (ce(D("clickAction"), u), D("dblClickAction")) {
      var _e2 = Date.now(),
        _t2 = _e2 - (w || _e2);
      w = _e2, _t2 > 0 && _t2 <= 250 ? (x && (clearTimeout(x), x = void 0), ce(D("dblClickAction"), u)) : x = setTimeout(function () {
        ce(D("singleClickAction"), u);
      }, 250);
    }
  }
  function _(e) {
    if (Z = e, !I() || !K()) return;
    if (R.scale <= 1 || P.scale <= 1) return;
    if (((null == E ? void 0 : E.dataset.animationName) || "").indexOf("zoom") > -1) return;
    var t = Q(P.scale);
    if (!t) return;
    var n = t.x,
      i = t.y;
    ce(p.Pan, {
      deltaX: n - P.x,
      deltaY: i - P.y
    });
  }
  function B() {
    var e;
    c && (d(c, "is-loading"), null === (e = c.querySelector(".f-spinner")) || void 0 === e || e.remove());
  }
  function N() {
    if (!c || !C) return;
    if (B(), m(C) && (!C.complete || !C.naturalWidth)) return L = 2, null == E || E.classList.add("has-error"), void H("error");
    H("loaded");
    var _G = G(),
      e = _G.width,
      t = _G.height;
    m(C) && (C.setAttribute("width", e + ""), C.setAttribute("height", t + "")), E && (d(E, "has-error"), m(C) && (E.setAttribute("width", e + ""), E.setAttribute("height", t + ""), E.style.aspectRatio = "".concat(e / t || ""))), T = a().on("start", function (e, t) {
      P = Object.assign(Object.assign({}, b), t), void 0 !== t.angle && (t.angle = 90 * Math.round(t.angle / 90)), void 0 !== t.flipX && (t.flipX = t.flipX > 0 ? 1 : -1), void 0 !== t.flipY && (t.flipY = t.flipY > 0 ? 1 : -1), le(), H("animationStart");
    }).on("pause", function (e) {
      P = Object.assign(Object.assign({}, b), e);
    }).on("step", function (e) {
      if (!I()) return void (null == T || T.end());
      if (R = Object.assign(Object.assign({}, b), e), K() || !D("bounds") || ve() || P.scale > R.scale || P.scale < ne()) return void ue();
      var t = se(P.scale);
      var n = !1,
        i = !1,
        a = !1,
        s = !1;
      R.x < t.x[0] && (n = !0), R.x > t.x[1] && (i = !0), R.y < t.y[0] && (s = !0), R.y > t.y[1] && (a = !0);
      var r = !1,
        l = !1,
        c = !1,
        u = !1;
      P.x < t.x[0] && (r = !0), P.x > t.x[1] && (l = !0), P.y < t.y[0] && (u = !0), P.y > t.y[1] && (c = !0);
      var d = !1;
      (i && l || n && r) && (P.x = o(t.x[0], P.x, t.x[1]), d = !0), (a && c || s && u) && (P.y = o(t.y[0], P.y, t.y[1]), d = !0), d && T && T.spring({
        tension: 94,
        friction: 17,
        maxSpeed: 555 * P.scale,
        restDelta: .1,
        restSpeed: .1,
        velocity: T.getCurrentVelocities()
      }).from(R).to(P).start(), ue();
    }).on("end", function () {
      re(), (null == T ? void 0 : T.isRunning()) || (le(), H("animationEnd"));
    }), function () {
      var e = D("gestures");
      e && A && C && (S = l(A, e).on("start", function (e) {
        if (!T) return;
        var t = e.srcEvent;
        K() || ((R.scale > 1 || e.currentTouch.length > 1) && (null == t || t.stopPropagation(), T.pause()), 1 === e.currentTouch.length && H("touchStart"));
      }).on("move", function (e) {
        K() || (1 !== P.scale || e.currentTouch.length > 1) && (e.srcEvent.preventDefault(), e.srcEvent.stopPropagation());
      }).on("pan", function (e) {
        if (!I() || K()) return;
        var t = e.srcEvent;
        (1 !== P.scale || e.currentTouch.length > 1) && (g(t), ce(p.Pan, e));
      }).on("swipe", function (e) {
        I() && !K() && P.scale > 1 && ce(p.Swipe, e);
      }).on("tap", function (e) {
        H("click", e);
      }).on("singleTap", function (e) {
        H("singleClick", e);
      }).on("doubleTap", function (e) {
        H("dblClick", e);
      }).on("pinch", function (e) {
        K() || (e.scale > ne() ? ce(p.ZoomIn, e) : e.scale < ne() ? ce(p.ZoomOut, e) : ce(p.Pan, e));
      }).on("end", function (e) {
        K() || (e.currentTouch.length ? (e.srcEvent.stopPropagation(), g(e.srcEvent), null == T || T.end()) : (le(), re(), H("touchEnd")));
      }).init());
    }(), A && (A.addEventListener("wheel", q, {
      passive: !1
    }), z.push(function () {
      null == A || A.removeEventListener("wheel", q, {
        passive: !1
      });
    })), null == c || c.addEventListener("click", $), null === document || void 0 === document || document.addEventListener("mousemove", _), z.push(function () {
      null == c || c.removeEventListener("click", $), null === document || void 0 === document || document.removeEventListener("mousemove", _);
    });
    var n = V();
    R = Object.assign({}, n), P = Object.assign({}, n), L = 3, ue(), le(), H("ready"), requestAnimationFrame(function () {
      B(), A && (A.style.visibility = "");
    });
  }
  function V() {
    var e = Object.assign({}, D("startPos") || {});
    var t = e.scale,
      n = 1;
    n = "string" == typeof t ? ee(t) : "number" == typeof t ? t : ne();
    var i = Object.assign(Object.assign(Object.assign({}, b), e), {
        scale: n
      }),
      o = K() ? Q(n) : void 0;
    if (o) {
      var _e3 = o.x,
        _t3 = o.y;
      i.x = _e3, i.y = _t3;
    }
    return i;
  }
  function U() {
    var e = {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    };
    if (E) {
      var _t4 = E.getBoundingClientRect();
      P.angle % 180 == 90 ? (e.top = _t4.top + .5 * _t4.height - .5 * _t4.width, e.left = _t4.left + .5 * _t4.width - .5 * _t4.height, e.width = _t4.height, e.height = _t4.width) : (e.top = _t4.top, e.left = _t4.left, e.width = _t4.width, e.height = _t4.height);
    }
    return e;
  }
  function G() {
    var t = D("width"),
      n = D("height");
    if (C && "auto" === t) {
      var _e4 = C.getAttribute("width");
      t = _e4 ? parseFloat(_e4 + "") : void 0 !== C.dataset.width ? parseFloat(C.dataset.width + "") : m(A) ? A.naturalWidth : m(C) ? C.naturalWidth : C.getBoundingClientRect().width;
    } else t = e(t) ? parseFloat(t) : t;
    if (C && "auto" === n) {
      var _e5 = C.getAttribute("height");
      n = _e5 ? parseFloat(_e5 + "") : void 0 !== C.dataset.height ? parseFloat(C.dataset.height + "") : m(A) ? A.naturalHeight : m(C) ? C.naturalHeight : C.getBoundingClientRect().height;
    } else n = e(n) ? parseFloat(n) : n;
    return {
      width: t,
      height: n
    };
  }
  function J() {
    var e = U();
    return {
      width: e.width,
      height: e.height
    };
  }
  function K() {
    return "mousemove" === D("panMode") && matchMedia("(hover: hover)").matches;
  }
  function Q(e) {
    var t = Z || D("event"),
      n = null == E ? void 0 : E.getBoundingClientRect();
    if (!t || !n || e <= 1) return {
      x: 0,
      y: 0
    };
    var i = (t.clientX || 0) - n.left,
      a = (t.clientY || 0) - n.top,
      _J = J(),
      s = _J.width,
      r = _J.height,
      l = se(e);
    if (e > 1) {
      var _t5 = D("mouseMoveFactor");
      _t5 > 1 && (e *= _t5);
    }
    var c = s * e,
      u = r * e,
      d = .5 * (c - s) - i / s * 100 / 100 * (c - s),
      f = .5 * (u - r) - a / r * 100 / 100 * (u - r);
    return d = o(l.x[0], d, l.x[1]), f = o(l.y[0], f, l.y[1]), {
      x: d,
      y: f
    };
  }
  function ee() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "base";
    if (!c) return 1;
    var t = c.getBoundingClientRect(),
      n = U(),
      _G2 = G(),
      i = _G2.width,
      a = _G2.height,
      s = function s(e) {
        if ("number" == typeof e) return e;
        switch (e) {
          case "min":
          case "base":
            return 1;
          case "cover":
            return Math.max(t.height / n.height, t.width / n.width) || 1;
          case "full":
          case "max":
            {
              var _e6 = P.angle % 180 == 90 ? a : i;
              return _e6 && n.width ? _e6 / n.width : 1;
            }
        }
      },
      r = D("minScale"),
      l = D("maxScale"),
      u = Math.min(s("full"), s(r)),
      d = "number" == typeof l ? s("full") * l : Math.min(s("full"), s(l));
    switch (e) {
      case "min":
        return u;
      case "base":
        return o(u, 1, d);
      case "cover":
        return s("cover");
      case "full":
        return Math.min(d, s("full"));
      case "max":
        return d;
    }
  }
  function te() {
    return ee("min");
  }
  function ne() {
    return ee("base");
  }
  function ie() {
    return ee("cover");
  }
  function oe() {
    return ee("full");
  }
  function ae() {
    return ee("max");
  }
  function se(e) {
    var t = {
        x: [0, 0],
        y: [0, 0]
      },
      n = null == c ? void 0 : c.getBoundingClientRect();
    if (!n) return t;
    var i = U(),
      o = n.width,
      a = n.height;
    var s = i.width,
      r = i.height,
      l = e = void 0 === e ? P.scale : e,
      u = e;
    if (K() && e > 1) {
      var _t6 = D("mouseMoveFactor");
      _t6 > 1 && (s * e > o + .01 && (l *= _t6), r * e > a + .01 && (u *= _t6));
    }
    return s *= l, r *= u, e > 1 && (s > o && (t.x[0] = .5 * (o - s), t.x[1] = .5 * (s - o)), t.x[0] -= .5 * (i.left - n.left), t.x[1] -= .5 * (i.left - n.left), t.x[0] -= .5 * (i.left + i.width - n.right), t.x[1] -= .5 * (i.left + i.width - n.right), r > a && (t.y[0] = .5 * (a - r), t.y[1] = .5 * (r - a)), t.y[0] -= .5 * (i.top - n.top), t.y[1] -= .5 * (i.top - n.top), t.y[0] -= .5 * (i.top + i.height - n.bottom), t.y[1] -= .5 * (i.top + i.height - n.bottom)), t;
  }
  function re() {
    if (!I()) return;
    if (!D("bounds")) return;
    if (!T) return;
    var e = te(),
      t = ae(),
      n = o(e, P.scale, t);
    if (P.scale < e - .01 || P.scale > t + .01) return void ce(p.ZoomTo, {
      scale: n
    });
    if (T.isRunning()) return;
    if (ve()) return;
    var i = se(n);
    P.x < i.x[0] || P.x > i.x[1] || P.y < i.y[0] || P.y > i.y[1] ? (P.x = o(i.x[0], P.x, i.x[1]), P.y = o(i.y[0], P.y, i.y[1]), T.spring({
      tension: 170,
      friction: 17,
      restDelta: .001,
      restSpeed: .001,
      maxSpeed: 1 / 0,
      velocity: T.getCurrentVelocities()
    }), T.from(R).to(P).start()) : ue();
  }
  function le() {
    if (!I()) return;
    var e = pe(),
      t = ve(),
      n = be(),
      i = ye(),
      o = fe(),
      a = ge();
    f(E, "is-fullsize", i), f(E, "is-expanded", n), f(E, "is-dragging", t), f(E, "can-drag", e), f(E, "will-zoom-in", o), f(E, "will-zoom-out", a);
    var s = he(),
      r = me(),
      l = !I();
    var _iterator2 = _createForOfIteratorHelper((null == c ? void 0 : c.querySelectorAll("[data-panzoom-action]")) || []),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _e7 = _step2.value;
        var _t7 = _e7.dataset.panzoomAction;
        var _n2 = !1;
        if (l) _n2 = !0;else switch (t) {
          case p.ZoomIn:
            s || (_n2 = !0);
            break;
          case p.ZoomOut:
            r || (_n2 = !0);
            break;
          case p.ToggleFull:
            s || r || (_n2 = !0);
            var _t8 = _e7.querySelector("g");
            _t8 && (_t8.style.display = i ? "none" : "");
            break;
          case p.ToggleCover:
          case p.ToggleMax:
            s || r || (_n2 = !0);
        }
        _n2 ? (_e7.setAttribute("aria-disabled", ""), _e7.setAttribute("tabindex", "-1")) : (_e7.removeAttribute("aria-disabled"), _e7.removeAttribute("tabindex"));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  function ce(e, t) {
    var n;
    if (!c || !C || !T) return;
    if (e === p.Swipe && Math.abs(T.getCurrentVelocities().scale) > .01) return;
    var i = Object.assign({}, P),
      a = se(K() ? P.scale : R.scale);
    var l = T.getCurrentVelocities(),
      u = U(),
      d = ((null === (n = (t = t || {}).currentTouch) || void 0 === n ? void 0 : n.length) || 0) > 1,
      f = t.velocityX || 0,
      g = t.velocityY || 0;
    var h = t.center;
    !h && t.srcEvent && (h = s(r(t.srcEvent)));
    var m = t.deltaX || 0,
      v = t.deltaY || 0;
    switch (e) {
      case p.MoveRight:
        m = t.deltaX || 100;
        break;
      case p.MoveLeft:
        m = t.deltaX || -100;
        break;
      case p.MoveUp:
        v = t.deltaY || -100;
        break;
      case p.MoveDown:
        v = t.deltaY || 100;
    }
    var y = [];
    switch (e) {
      case p.Reset:
        P = Object.assign({}, b), P.scale = ne();
        break;
      case p.Pan:
      case p.Move:
      case p.MoveLeft:
      case p.MoveRight:
      case p.MoveUp:
      case p.MoveDown:
        if (ve()) {
          var _e8 = 1,
            _t9 = 1;
          P.x <= a.x[0] && f <= 0 && (_e8 = Math.max(.01, 1 - Math.abs(1 / u.width * Math.abs(P.x - a.x[0]))), _e8 *= .2), P.x >= a.x[1] && f >= 0 && (_e8 = Math.max(.01, 1 - Math.abs(1 / u.width * Math.abs(P.x - a.x[1]))), _e8 *= .2), P.y <= a.y[0] && g <= 0 && (_t9 = Math.max(.01, 1 - Math.abs(1 / u.height * Math.abs(P.y - a.y[0]))), _t9 *= .2), P.y >= a.y[1] && g >= 0 && (_t9 = Math.max(.01, 1 - Math.abs(1 / u.height * Math.abs(P.y - a.y[1]))), _t9 *= .2), P.x += m * _e8, P.y += v * _t9;
        } else P.x = o(a.x[0], P.x + m, a.x[1]), P.y = o(a.y[0], P.y + v, a.y[1]);
        break;
      case p.Swipe:
        var _e9 = function _e9() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return Math.sign(e) * Math.pow(Math.abs(e), 1.5);
        };
        P.x += o(-1e3, _e9(f), 1e3), P.y += o(-1e3, _e9(g), 1e3), g && !f && (P.x = o(a.x[0], P.x, a.x[1])), !g && f && (P.y = o(a.y[0], P.y, a.y[1])), l.x = f, l.y = g;
        break;
      case p.ZoomTo:
        P.scale = t.scale || 1;
        break;
      case p.ZoomIn:
        P.scale = P.scale * (t.scale || 2), d || (P.scale = Math.min(P.scale, ae()));
        break;
      case p.ZoomOut:
        P.scale = P.scale * (t.scale || .5), d || (P.scale = Math.max(P.scale, te()));
        break;
      case p.ToggleCover:
        y = [ne(), ie()];
        break;
      case p.ToggleFull:
        y = [ne(), oe()];
        break;
      case p.ToggleMax:
        y = [ne(), ae()];
        break;
      case p.IterateZoom:
        y = [ne(), oe(), ae()];
        break;
      case p.Zoom:
        var _n3 = oe();
        P.scale >= _n3 - .05 ? P.scale = ne() : P.scale = Math.min(_n3, P.scale * (t.scale || 2));
        break;
      case p.RotateCW:
        P.angle += 90;
        break;
      case p.RotateCCW:
        P.angle -= 90;
        break;
      case p.FlipX:
        P.flipX *= -1;
        break;
      case p.FlipY:
        P.flipY *= -1;
    }
    if (void 0 !== R.angle && Math.abs(R.angle) >= 360 && (P.angle -= 360 * Math.floor(R.angle / 360), R.angle -= 360 * Math.floor(R.angle / 360)), y.length) {
      var _e10 = y.findIndex(function (e) {
        return e > P.scale + 1e-4;
      });
      P.scale = y[_e10] || y[0];
    }
    if (d && (P.scale = o(te() * (d ? .8 : 1), P.scale, ae() * (d ? 1.6 : 1))), K()) {
      var _e11 = Q(P.scale);
      if (_e11) {
        var _t10 = _e11.x,
          _n4 = _e11.y;
        P.x = _t10, P.y = _n4;
      }
    } else if (P.scale !== i.scale) {
      var _e12 = 0,
        _t11 = 0;
      if (h) _e12 = h.x, _t11 = h.y;else {
        var _n5 = c.getBoundingClientRect();
        _e12 = _n5.x + .5 * _n5.width, _t11 = _n5.y + .5 * _n5.height;
      }
      var _n6 = _e12 - u.left,
        _s = _t11 - u.top;
      _n6 -= .5 * u.width, _s -= .5 * u.height;
      var _r = (_n6 - i.x) / i.scale,
        _l = (_s - i.y) / i.scale;
      P.x = _n6 - _r * P.scale, P.y = _s - _l * P.scale, !d && D("bounds") && (a = se(), P.x = o(a.x[0], P.x, a.x[1]), P.y = o(a.y[0], P.y, a.y[1]));
    }
    if (e === p.Swipe) {
      var _e13 = 94,
        _t12 = 17,
        _n7 = 500 * P.scale,
        _i = l;
      T.spring({
        tension: _e13,
        friction: _t12,
        maxSpeed: _n7,
        restDelta: .1,
        restSpeed: .1,
        velocity: _i
      });
    } else e === p.Pan || d ? T.spring({
      tension: 900,
      friction: 17,
      restDelta: .01,
      restSpeed: .01,
      maxSpeed: 1
    }) : T.spring({
      tension: 170,
      friction: 17,
      restDelta: .001,
      restSpeed: .001,
      maxSpeed: 1 / 0,
      velocity: l
    });
    e === p.Reset || 0 === t.velocity ? R = Object.assign({}, P) : T.from(R).to(P).start(), H("action", e);
  }
  function ue() {
    if (!C) return;
    if (E) {
      var _G3 = G(),
        _e14 = _G3.width,
        _t13 = _G3.height;
      E.style.maxWidth = "min(".concat(_e14, "px, 100%)"), E.style.maxHeight = "min(".concat(_t13, "px, 100%)");
    }
    var _R = R,
      e = _R.x,
      t = _R.y,
      n = _R.scale,
      i = _R.angle,
      o = _R.flipX,
      a = _R.flipY;
    var s = function () {
      var _G4 = G(),
        e = _G4.width,
        t = _G4.height,
        _J2 = J(),
        n = _J2.width,
        i = _J2.height;
      if (!c) return {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        scale: 0,
        flipX: 0,
        flipY: 0,
        angle: 0,
        fitWidth: n,
        fitHeight: i,
        fullWidth: e,
        fullHeight: t
      };
      var _R2 = R,
        o = _R2.x,
        a = _R2.y,
        s = _R2.scale,
        r = _R2.angle,
        l = _R2.flipX,
        u = _R2.flipY,
        d = 1 / oe(),
        f = e,
        g = t,
        h = R.scale * d,
        m = P.scale * d;
      var p = Math.max(n, i),
        v = Math.min(n, i);
      e > t ? (f = p, g = v) : (f = v, g = p);
      h = e > t ? p * s / e || 1 : p * s / t || 1;
      var b = f ? e * m : 0,
        y = g ? t * m : 0;
      return o = o + .5 * f - .5 * b, a = a + .5 * g - .5 * y, {
        x: o,
        y: a,
        width: b,
        height: y,
        scale: f && g ? e * h / b : 0,
        flipX: l,
        flipY: u,
        angle: r,
        fitWidth: n,
        fitHeight: i,
        fullWidth: e,
        fullHeight: t
      };
    }();
    if (s) {
      var _e15 = s.x,
        _t14 = s.y,
        _n8 = s.width,
        _o = s.height,
        _a2 = s.scale,
        _r2 = s.flipX,
        _l2 = s.flipY;
      var _c = "translate(".concat(h(_e15), "px, ").concat(h(_t14), "px)");
      _c += 1 !== _r2 || 1 !== _l2 ? " scaleX(".concat(h(_a2 * _r2), ") scaleY(").concat(h(_a2 * _l2), ")") : " scale(".concat(h(_a2), ")"), 0 !== i && (_c += " rotate(".concat(i, "deg)")), A && (A.style.width = "".concat(h(_n8), "px"), A.style.height = "".concat(h(_o), "px"), A.style.transform = "".concat(_c));
    }
    H("render");
  }
  function de() {
    var e = P.scale;
    var t = D("clickAction");
    var n = ne();
    if (t) {
      var _i2 = [];
      switch (t) {
        case p.ZoomIn:
          n = 2 * e;
          break;
        case p.ZoomOut:
          n = .5 * e;
          break;
        case p.ToggleCover:
          _i2 = [ne(), ie()];
          break;
        case p.ToggleFull:
          _i2 = [ne(), oe()];
          break;
        case p.ToggleMax:
          _i2 = [ne(), ae()];
          break;
        case p.IterateZoom:
          _i2 = [ne(), oe(), ae()];
          break;
        case p.Zoom:
          var _t15 = oe();
          n = e >= _t15 - .05 ? ne() : Math.min(_t15, 2 * e);
      }
      if (_i2.length) {
        var _t16 = _i2.findIndex(function (t) {
          return t > e + 1e-4;
        });
        n = _i2[_t16] || ne();
      }
    }
    return n = o(te(), n, ae()), n;
  }
  function fe() {
    return !!(I() && de() > P.scale);
  }
  function ge() {
    return !!(I() && de() < P.scale);
  }
  function he() {
    return !!(I() && P.scale < ae());
  }
  function me() {
    return !!(I() && P.scale > te());
  }
  function pe() {
    return !(!(I() && be() && S) || K());
  }
  function ve() {
    return !(!I() || !(null == S ? void 0 : S.isPointerDown()) || K());
  }
  function be() {
    return !!(I() && P.scale > ne());
  }
  function ye() {
    return !!(I() && P.scale >= oe());
  }
  var xe = {
    canDrag: pe,
    canZoomIn: he,
    canZoomOut: me,
    destroy: function destroy() {
      H("destroy");
      for (var _i3 = 0, _Object$values = Object.values(Y); _i3 < _Object$values.length; _i3++) {
        var _e16 = _Object$values[_i3];
        null == _e16 || _e16.destroy(xe);
      }
      for (var _i4 = 0, _z = z; _i4 < _z.length; _i4++) {
        var _e17 = _z[_i4];
        _e17();
      }
      return E && (E.style.aspectRatio = "", E.style.maxWidth = "", E.style.maxHeight = ""), A && (A.style.width = "", A.style.height = "", A.style.transform = ""), E = void 0, C = void 0, A = void 0, R = Object.assign({}, b), P = Object.assign({}, b), null == T || T.destroy(), T = void 0, null == S || S.destroy(), S = void 0, L = 4, xe;
    },
    emit: H,
    execute: ce,
    getBoundaries: se,
    getContainer: function getContainer() {
      return c;
    },
    getContent: function getContent() {
      return C;
    },
    getFullDim: G,
    getGestures: function getGestures() {
      return S;
    },
    getMousemovePos: Q,
    getOptions: function getOptions() {
      return X;
    },
    getScale: ee,
    getStartPosition: V,
    getState: function getState() {
      return L;
    },
    getTransform: function getTransform(e) {
      return !0 === e ? P : R;
    },
    getTween: function getTween() {
      return T;
    },
    getViewport: function getViewport() {
      return A;
    },
    getWrapper: function getWrapper() {
      return E;
    },
    init: function init() {
      return L = 0, H("init"), function () {
        for (var _i5 = 0, _Object$entries = Object.entries(Object.assign(Object.assign({}, k), X.plugins || {})); _i5 < _Object$entries.length; _i5++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i5], 2),
            _e18 = _Object$entries$_i[0],
            _t17 = _Object$entries$_i[1];
          if (_e18 && !Y[_e18] && _t17 instanceof Function) {
            var _n9 = _t17();
            _n9.init(xe), Y[_e18] = _n9;
          }
        }
        H("initPlugins");
      }(), function () {
        var e = Object.assign(Object.assign({}, y.classes), D("classes"));
        if (!c) return;
        if (u(c, e.container), C = c.querySelector("." + e.content), !C) return;
        C.setAttribute("draggable", "false"), E = c.querySelector("." + e.wrapper), E || (E = document.createElement("div"), u(E, e.wrapper), C.insertAdjacentElement("beforebegin", E), E.insertAdjacentElement("afterbegin", C));
        A = c.querySelector("." + e.viewport), A || (A = document.createElement("div"), u(A, e.viewport), A.insertAdjacentElement("afterbegin", C), E.insertAdjacentElement("beforeend", A));
        O = C.cloneNode(!0), O.removeAttribute("id"), E.insertAdjacentElement("afterbegin", O), C instanceof HTMLPictureElement && (C = C.querySelector("img"));
        O instanceof HTMLPictureElement && (O = O.querySelector("img"));
        A instanceof HTMLPictureElement && (A = A.querySelector("img"));
        if (A && (A.style.visibility = "hidden", D("protected"))) {
          A.addEventListener("contextmenu", function (e) {
            e.preventDefault();
          });
          var _e19 = document.createElement("div");
          u(_e19, "f-panzoom__protected"), A.appendChild(_e19);
        }
        H("initLayout");
      }(), function () {
        if (c && E && !F) {
          var _e20 = null;
          F = new ResizeObserver(function () {
            I() && (_e20 = _e20 || requestAnimationFrame(function () {
              I() && (le(), re(), H("refresh")), _e20 = null;
            }));
          }), F.observe(E), z.push(function () {
            null == F || F.disconnect(), F = void 0, _e20 && (cancelAnimationFrame(_e20), _e20 = null);
          });
        }
      }(), function () {
        if (!c || !C) return;
        if (!m(C) || !m(O)) return void N();
        var e = function e() {
          C && m(C) && C.decode().then(function () {
            N();
          }).catch(function () {
            N();
          });
        };
        if (L = 1, c.classList.add("is-loading"), H("loading"), O.src && O.complete) return void e();
        (function () {
          if (!c) return;
          if (null == c ? void 0 : c.querySelector(".f-spinner")) return;
          var e = D("spinnerTpl"),
            t = i(e);
          t && (t.classList.add("f-spinner"), c.classList.add("is-loading"), null == E || E.insertAdjacentElement("afterbegin", t));
        })(), O.addEventListener("load", e, !1), O.addEventListener("error", e, !1), z.push(function () {
          null == O || O.removeEventListener("load", e, !1), null == O || O.removeEventListener("error", e, !1);
        });
      }(), xe;
    },
    isDragging: ve,
    isExpanded: be,
    isFullsize: ye,
    localize: function localize(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var n = D("l10n") || {};
      e = String(e).replace(/\{\{(\w+)\}\}/g, function (e, t) {
        return n[t] || e;
      });
      for (var _n10 = 0; _n10 < t.length; _n10++) e = e.split(t[_n10][0]).join(t[_n10][1]);
      return e = e.replace(/\{\{(.*?)\}\}/g, function (e, t) {
        return t;
      });
    },
    off: function off(e, t) {
      var _iterator3 = _createForOfIteratorHelper(e instanceof Array ? e : [e]),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _n11 = _step3.value;
          W.has(_n11) && W.set(_n11, W.get(_n11).filter(function (e) {
            return e !== t;
          }));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return xe;
    },
    on: function on(e, t) {
      var _iterator4 = _createForOfIteratorHelper(e instanceof Array ? e : [e]),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _n12 = _step4.value;
          W.set(_n12, [].concat(_toConsumableArray(W.get(_n12) || []), [t]));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return xe;
    },
    version: "6.0.29",
    willZoomIn: fe,
    willZoomOut: ge
  };
  return xe;
};
k.l10n = {
  en_EN: c
}, k.getDefaults = function () {
  return y;
};
export { b as PANZOOM_DEFAULT_POS, k as Panzoom, p as PanzoomAction, v as PanzoomZoomLevel };